const set = require('regenerate')(0x1CD5, 0x1CE2, 0x1CF2);
set.addRange(0x951, 0x952).addRange(0x964, 0x965).addRange(0xA830, 0xA839).addRange(0x11480, 0x114C7).addRange(0x114D0, 0x114D9);
exports.characters = set;
